export default __webpack_public_path__ + "static/media/mountains-c.a3f38943.jpg";